import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import { useCallback } from 'react'; // The maximum number of records crmsearch can page through

const RESULTSET_LIMIT = 10000;

const Paginator = ({
  pageIndex,
  pageSize,
  pageSizes,
  totalRowCount,
  onPageIndexChange,
  onPageSizeChange
}) => {
  const pageCount = Math.ceil(totalRowCount / pageSize); // The paginator treats the page numbers as 1-indexed, while the table api treats
  // them as 0-indexed. This is why we subtract 1 in this callback and add 1 in the prop.

  const handlePageChange = useCallback(({
    target: {
      value
    }
  }) => onPageIndexChange({
    nextPageIndex: value - 1
  }), [onPageIndexChange]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    className: "width-100",
    align: "center",
    justify: "center",
    children: [/*#__PURE__*/_jsx(UIPaginator, {
      "data-test-id": "table-paginator",
      page: pageIndex + 1,
      pageCount: pageCount,
      onPageChange: handlePageChange,
      enabledPageLimit: RESULTSET_LIMIT / pageSize,
      disabledPageTooltipTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.pagination.tooManyRecords"
      })
    }), /*#__PURE__*/_jsx(UIDropdown, {
      "data-test-id": "table-page-size-selector",
      "data-test-value": pageSize,
      buttonUse: "transparent",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.pagination.pageCountButton",
        options: {
          count: pageSize
        }
      }),
      children: /*#__PURE__*/_jsx(UIList, {
        children: pageSizes.map(size => /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": `page-size-${size}`,
          use: "link",
          onClick: () => onPageSizeChange({
            nextPageSize: size
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "datatable.pagination.pageCountButton",
            options: {
              count: size
            }
          })
        }, size))
      })
    })]
  });
};

export default Paginator;